import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { SiDataService } from '../services/si-data.service';
import { ISiFilters } from './interfaces/si-filters.interface';
import { AppService } from '../app.service';
import { combineAll } from 'rxjs/operators';

@Injectable()
export class SiFiltersService {

  customListUrl: string = 'file/getCustomListOneFileNames';
  stateAndNpaUrl: string = 'data/getStateAndNPA';
  clientIDUrl: string = 'data/getClientIDList';
  productIDUrl: string = 'data/getProductIDList';
  carrierScoreUrl: string = 'data/getCarrierScores';
  customDownload: string = 'file/getCustomListOneFileContents';
  customDelete: string = 'file/deleteCustomListOne';
  customUpload: string = 'file/uploadCustomListOne';
  origIdListUrl: string = 'file/getOrigidFileNames';
  clientIdListUrl: string = 'file/getClientFileNames';
  ipAddressListUrl: string = 'file/getIpaddressFileNames';
  origIDDownload: string = 'file/getOrigidFileContents';
  origIDDelete: string = 'file/deleteOrigidFile';
  origIDUpload: string = 'file/uploadOrigidFile';
  clientIDupload: string = 'file/uploadClientFile';
  clientIDDelete: string = 'file/deleteClientFile';
  clientIDDownload: string = 'file/getClientFileContents';
  ipAddressListUpload: string = 'file/uploadIpaddressFile';
  ipAddressListDelete: string = 'file/deleteIpaddressFile';
  ipAddressListDownload: string = 'file/getIpaddressFileContents';
  // fraudPolicyUrl: string = 'data/getCarrierBuckets';
  fraudPolicyUrl: string = 'scoredata/getCarrierFraudPolicy';
  ipAddressUrl: string = 'data/getCarrierIPaddress';
  filterKey: string = 'applied_filters';
  filters: ISiFilters;
  defaultMaxMinDates: Array<object>;
  currentTab: string;
  headerTitleObj =
    {
      'customList': {
        'tn': 'TN',
        'score': 'Score',
        'remarks': 'Remarks'
      },
      'origIdList': {
        'origid': 'Origid'
      }
    };

  constructor(private siDataService: SiDataService, private appService: AppService) { }

  setFiltersToStorage(filters: ISiFilters, tab: string, customerName: string): void {
    let filtersToSave = [];
    if (typeof (Storage) === "undefined") {
      return;
    }
    const currentStorage = sessionStorage.getItem("applied_filters");
    if (currentStorage) {
      const appliedFiltersOnStorage = JSON.parse(currentStorage);
      if (appliedFiltersOnStorage.find((filter: any) => filter.customerName === customerName)) {
        filtersToSave = appliedFiltersOnStorage.map((filter: any) => {
          if (filter.customerName === customerName) {
            if (filter.value.some((tabData: any) => tabData.tab === tab)) {
              for (let filterValue of filter.value) {
                if (filterValue.tab === tab) {
                  filterValue["filters"] = filters;
                }
              }
              return { ...filter, value: filter.value };
            } else {
              return { ...filter, value: filter.value.concat({ tab, filters }) };
            }
          }
          return { ...filter };
        });
      } else {
        filtersToSave = appliedFiltersOnStorage.concat({ customerName, value: [{ tab, filters }] });
      }
    } else {
      filtersToSave = [{
        customerName,
        value: [{ tab, filters }]
      }];
    }
    sessionStorage.setItem("applied_filters", JSON.stringify(filtersToSave));
  }

  setFilters(filters: ISiFilters): void {
    this.filters = filters;
  }

  setCurrentTab(tab: string): void {
    this.currentTab = tab;
  }

  getFilters(): ISiFilters {
    // Filter Implementation
    if (sessionStorage.getItem(this.filterKey)) {
      const currentCommonConstants = this.appService.getCommonConstants();
      if (currentCommonConstants && currentCommonConstants['customerDisplayName']) {
        const appliedFilters = JSON.parse(sessionStorage.getItem(this.filterKey));
        const currentCustomerFilters = appliedFilters.find((filters: any) => filters.customerName === currentCommonConstants['customerDisplayName']);
        if (currentCustomerFilters && currentCustomerFilters.value) {
          for (let filterValue of currentCustomerFilters.value) {
            if (filterValue.tab === this.currentTab) {
              if (localStorage.getItem("threshold")) {
                return { ...filterValue.filters, threshold: { isApplied: true, hr_threshold: localStorage.getItem("threshold") } };
              }
              return filterValue.filters;
            }
          }
        }
      }
    }
    return this.filters;
  }

  getFilesList(params, serviceURL): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.siDataService.getDataByParam(serviceURL, params)
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  getStateAndNpa(): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.siDataService.getData(this.stateAndNpaUrl)
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  getOverlayScoreData(params): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.siDataService.getDataByParam(this.carrierScoreUrl, params)
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  getFraudPolicyData(params): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.siDataService.getDataByParam(this.fraudPolicyUrl, params)
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  getIpAddressData(params): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.siDataService.getDataByParam(this.ipAddressUrl, params)
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  getClientIDData(params): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.siDataService.getDataByParam(this.clientIDUrl, params)
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  getProductIDListData(): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.siDataService.getData(this.productIDUrl)
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  setParams(filterData): object {
    const params: object = {};
    for (const key of Object.keys(filterData)) {
      // for (const key in filterData) {
      switch (key) {
        case 'carrier':
          if (filterData[key] && filterData[key].isApplied) {
            params['carrier'] = filterData[key]['carrier'];
          }
          break;
        case 'carrierTypeIn':
          if (filterData[key] && filterData[key].isApplied) {
            params['filter_type'] = filterData[key]['filter_type'];
            params['termination_carrier'] = filterData[key]['termination_carrier'];
          }
          break;
        case 'carrierTypeOut':
          if (filterData[key] && filterData[key].isApplied) {
            params['filter_type'] = filterData[key]['filter_type'];
            params['origination_carrier'] = filterData[key]['origination_carrier'];
          }
          break;
        case 'dateFilterObj':
          if (filterData[key] && filterData[key].isApplied) {
            const transformedDate = this.transformDate(filterData[key].dates);
            if (filterData[key]['date']) {
              params['date'] = transformedDate;
            } else {
              params['dateRange'] = transformedDate;
            }
            params['timeFrameFilter'] = filterData[key]['groupBy'];
          }
          break;
        case 'customList':
          if (filterData[key] && filterData[key].isApplied) {
            params['custom_list_one_file_name'] = filterData[key]['custom_list_one_file_name'];
          }
          break;
        case 'telephone':
          if (filterData[key] && filterData[key].isApplied) {
            if (filterData[key]['npa']) {
              params['npa'] = filterData[key]['npa'];
            } else {
              params['excluded_npa'] = filterData[key]['excluded_npa'];
            }
          }
          break;
        case 'states':
          if (filterData[key] && filterData[key].isApplied) {
            params['state_npa'] = filterData[key]['state_npa'];
          }
          break;
        case 'score':
          if (filterData[key] && filterData[key].isApplied && !filterData[key].isAllSelected) {
            params['carrier_score'] = filterData[key]['score'];
          }
          break;
        case 'tnLimit':
          if (filterData[key] && filterData[key].isApplied) {
            params['top_tn_count'] = filterData[key]['top_tn_count'];
          }
          break;
        case 'sortOverlay':
          if (filterData[key] && filterData[key].isApplied) {
            params['sort_by'] = filterData[key]['sort_by'];
            params['sort_order'] = filterData[key]['sort_order'];
            params['limit'] = filterData[key]['limit'];
          }
          break;
        case 'threshold':
          if (filterData[key] && filterData[key].isApplied) {
            params['hr_threshold'] = filterData[key]['hr_threshold'];
          }
          break;
        case 'limit':
          if (filterData[key] && filterData[key].isApplied) {
            params['limit'] = filterData[key]['limit'];
          }
          break;
        case 'tn':
          if (filterData[key] && filterData[key].isApplied) {
            params['tn'] = filterData[key]['tn'];
          }
          break;
        case 'tollFree':
          if (filterData[key] && filterData[key].isApplied) {
            params['toll_free_numbers'] = filterData[key]['toll_free_numbers'];
          }
          break;
        case 'sortCategory':
          if (filterData[key] && filterData[key].isApplied) {
            params['limit'] = filterData[key]['limit'];
            params['sort_order'] = filterData[key]['sort_order'];
          }
          break;
        case 'sortBy':
          if (filterData[key] && filterData[key].isApplied) {
            params['sort_by'] = filterData[key]['sort_by'];
          }
          break;
        case 'fraudPolicyList':
          if (filterData[key] && filterData[key].isApplied) {
            params['bucket'] = filterData[key]['bucket'];
          }
          break;
        case 'first_telephone_number':
          if (filterData[key] && filterData[key].isApplied) {
            params['tn'] = filterData[key]['telephone_number'];
          }
          break;
        case 'categoryList':
          if (filterData[key] && filterData[key].isApplied) {
            params['category_id'] = filterData[key]['category_id'];
          }
          break;
        case 'subCategoryList':
          if (filterData[key] && filterData[key].isApplied) {
            params['sub_category_id'] = filterData[key]['sub_category_id'];
          }
          break;
        case 'special_tn_type':
          if (filterData[key] && filterData[key].isApplied) {
            params['category_id'] = filterData[key]['category_id'];
          }
          break;
        case 'invalid_tn':
          if (filterData[key] && filterData[key].isApplied) {
            params['invalid_tn'] = filterData[key]['invalid_tn'];
          }
          break;
        case 'bus_res':
          if (filterData[key] && filterData[key].isApplied) {
            params['bus_res'] = filterData[key]['bus_res'];
          }
          break;
        case 'ocnType':
          if (filterData[key] && filterData[key].isApplied) {
            params['ocn_type'] = filterData[key]['ocnType'];
          }
          break;
        case 'viewType':
          if (filterData[key] && filterData[key].isApplied) {
            params['view_type'] = filterData[key]['viewType'];
          }
          break;
        case 'fraud_threshold':
          if (filterData[key] && filterData[key].isApplied) {
            params['fraud_threshold'] = filterData[key]['fraud_threshold'];
          }
          break;
        case 'ip_address':
          if (filterData[key] && filterData[key].isApplied) {
            params['ip_address'] = filterData[key]['ip_address'];
          }
          break;

        case 'verstat_type':
          if (filterData[key] && filterData[key].isApplied) {
            params['verstat_type'] = filterData[key]['verstat_type'];
          }
          break;

        case 'signing_type':
          if (filterData[key] && filterData[key].isApplied) {
            params['signing_type'] = filterData[key]['signing_type'];
          }
          break;

        case 'productid_type':
          if (filterData[key] && filterData[key].isApplied) {
            params['productid_type'] = filterData[key]['productid_type'];
          }
          break;

        case 'clientID_type':
          if (filterData[key] && filterData[key].isApplied) {
            params['clientID_type'] = filterData[key]['clientID_type'];
          }
          break;

        case 'attestation_type':
          if (filterData[key] && filterData[key].isApplied) {
            params['attestation_type'] = filterData[key]['attestation_type'];
          }
          break;

        case 'origIdList':
          if (filterData[key] && filterData[key].isApplied) {
            params['origId_list_one_file_name'] = filterData[key]['origId_list_one_file_name'];
          }
          break;

        case 'exclusion_clientID_type_list':
          if (filterData[key] && filterData[key].isApplied) {
            params['exclusion_clientID_type_list'] = filterData[key]['exclusion_clientID_type_list'];
          }
          break;

        case 'ipAddressList':
          if (filterData[key] && filterData[key].isApplied) {
            params['IpAddress_list_one_file_name'] = filterData[key]['IpAddress_list_one_file_name'];
          }
          break;
        default:
          break;
      }
    }
    return params;
  }

  transformDate(dateObj) {
    let datestring: string = '';
    dateObj = this.appService.sortDates(dateObj);
    dateObj.forEach(val => {
      let month = '' + (new Date(val.date).getMonth() + 1),
        day = '' + new Date(val.date).getDate();
      const year = new Date(val.date).getFullYear();

      if (month.length < 2) { month = '0' + month; }
      if (day.length < 2) { day = '0' + day; }
      datestring += [year, month, day].join('-') + ',';
    });
    datestring = datestring.slice(0, -1);
    return datestring;
  }

  setDefaultMaxMinDate(dates: Array<object>): void {
    this.defaultMaxMinDates = dates;
  }

  getDefaultMaxMinDate(): Array<object> {
    return this.defaultMaxMinDates;
  }

  // Download filter files (Custom list, OrigID etc) from server
  downloadFilterFile(params, url): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.siDataService.getDataByParam(url, params)
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  // Delete filter files (Custom list, OrigID etc) from server
  deleteFilterFile(params, url): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.siDataService.getDataByParam(url, params)
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  // Upload filter files (Custom list, OrigID etc) from server
  uploadFilterFile(file, params, url): Observable<Array<object>> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return new Observable<Array<object>>((observer) => {
      this.siDataService.uploadData(url, params, formData)
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  prepareAndDownloadFile(data, fileObj, fileListType) {
    let jsonObject, str;
    data.forEach(value => {
      delete value.id;
      delete value.created_by;
      delete value.created_date;
      delete value.filename;
    });

    jsonObject = JSON.stringify(this.setHeaderForCsv(data));
    str = this.jsonToCsv(jsonObject, this.headerTitleObj[fileListType], fileListType);

    return this.downloadFileFilter(str, fileObj.file_name);
  }

  jsonToCsv(objArray, orderArr, fileListType) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let headersDone = false;
    for (let i = 0; i < array.length; i++) {
      let line = '';
      if (orderArr) {
        for (const key in orderArr) {
          if (array[i][key] !== undefined) {
            if (line !== '') {
              line += ',';
            }
            if (!headersDone) {
              line += this.headerTitleObj[fileListType][array[i][key]];
            } else {
              line += array[i][key];
            }
          }
        }
        headersDone = true;
      }
      str += line + '\r\n';
    }
    return str;
  }

  setHeaderForCsv(arr) {
    const tempArray = [];
    const tempObj = {};
    for (const key of Object.keys(arr[0])) {
      // for (const key in arr[0]) {
      tempObj[key] = key;
    }

    tempArray.push(tempObj);
    arr.forEach(obj => {
      tempArray.push(obj);
    });
    return tempArray;
  }

  downloadFileFilter(content, name) {
    const a = document.createElement('a');
    const blob = new Blob(
      [content],
      {
        type: 'application/csv'
      });
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.target = '_blank';
    a.download = name;
    document.body.appendChild(a);
    a.click();
    return true;
  }

}
